/**
 * 融易推相关路由配置
 */
import { AppRouteRecordRaw } from '@/router/types'

export const rytRoutes: AppRouteRecordRaw[] = [
  {
    path: 'ryt',
    name: 'RYT',
    redirect: '/ryt/productManage',
    meta: {
      title: '展业管理',
      keepAlive: true
    },
    children: [
      {
        path: 'productManage',
        name: 'ProductManage',
        component: () => import('@/views/ryt/productManage/index.vue'),
        meta: {
          title: '产品管理'
        }
      },

      {
        path: 'channelManage',
        name: 'ChannelManage',
        component: () => import('@/views/ryt/channelManage/index.vue'),
        meta: {
          title: '渠道管理'
        }
      },
      {
        path: 'channelManage/:id',
        name: 'ChannelManageDetail',
        component: () => import('@/views/ryt/channelManage/detail/index.vue'),
        meta: {
          title: '渠道详情'
        }
      },
      {
        path: 'fundPartyManage',
        name: 'FundPartyManage',
        component: () => import('@/views/ryt/fundPartyManage/index.vue'),
        meta: {
          title: '资金方管理'
        }
      },
      {
        path: 'incomingOrderManage',
        name: 'IncomingOrderManage',
        component: () => import('@/views/ryt/incomingOrderManage/index.vue'),
        meta: {
          keepAlive: true,
          title: '进件订单管理'
        }
      },
      {
        path: 'productConsult',
        name: 'productConsult',
        component: () => import('@/views/ryt/productConsult/index.vue'),
        meta: {
          keepAlive: true,
          title: '产品咨询跟进'
        }
      },
      {
        path: 'incomingOrderManage/:id',
        name: 'IncomingOrderManageDetail',
        component: () => import('@/views/ryt/incomingOrderManage/detail/index.vue'),
        meta: {
          title: '订单详情'
        }
      },
      {
        path: 'financialManage',
        name: 'FinancialManage',
        meta: {
          title: '财务管理'
        },
        children: [
          {
            path: 'billManage',
            name: 'RytBillManage',
            component: () => import('@/views/ryt/financeManage/commissionBill/index.vue'),
            meta: {
              title: '账单管理',
              keepAlive: true
            }
          },
          {
            path: 'billFinancialManage',
            name: 'RytBillFinancialManage',
            component: () => import('@/views/ryt/financeManage/billFinancialManage/index.vue'),
            meta: {
              title: '账单管理-财务',
              keepAlive: true
            }
          },
          {
            path: 'billManage/:id',
            name: 'commissionBillDetail',
            component: () => import('@/views/ryt/financeManage/commissionBill/detail/index.vue'),
            meta: {
              title: '账单详情'
            }
          },
          {
            path: 'billFinancialManage/:id',
            name: 'FinancialBillDetail',
            component: () =>
              import('@/views/ryt/financeManage/billFinancialManage/detail/index.vue'),
            meta: {
              title: '账单详情'
            }
          },
          {
            path: 'cashOutManage',
            name: 'CashOutManage',
            component: () => import('@/views/ryt/financeManage/cashOut/index.vue'),
            meta: {
              title: '提现管理'
            }
          },
          {
            path: 'cashOutManage/:id',
            name: 'cashOutManageDetail',
            component: () => import('@/views/ryt/financeManage/cashOut/detail/index.vue'),
            meta: {
              title: '提现详情'
            }
          },
          {
            path: 'signAuth',
            name: 'contractSigning',
            component: () => import('@/views/ryt/financeManage/contractSigning/index.vue'),
            meta: {
              title: '提现合同签署'
            }
          }
        ]
      },
      {
        path: 'enterpriseManage',
        name: 'EnterpriseManage',
        meta: {
          title: '企业管理'
        },
        children: [
          {
            path: 'enterpriseAccount',
            name: 'EnterpriseAccount',
            component: () => import('@/views/ryt/enterpriseManage/enterpriseAccount/index.vue'),
            meta: {
              title: '企业账户'
            }
          }
        ]
      },

      {
        path: 'applicationList',
        name: 'ApplicationList',
        component: () => import('@/views/ryt/applicationList/index.vue'),
        meta: {
          title: '申请列表'
        }
      },
      {
        path: 'brokerCard',
        name: 'BrokerCard',
        component: () => import('@/views/ryt/brokerCard/index.vue'),
        meta: {
          title: '经纪人名片'
        }
      },
      {
        path: 'brokerGroup',
        name: 'BrokerGroup',
        component: () => import('@/views/ryt/brokerGroup/index.vue'),
        meta: {
          title: '经纪人社群'
        }
      },
      {
        path: 'dataBoard',
        name: 'DataBoard',
        component: () => import('@/views/ryt/dataBoard/index.vue'),
        meta: {
          title: '数据看板'
        }
      },
      {
        path: 'applicationCenter',
        name: 'ApplicationCenter',
        meta: {
          title: '应用中心'
        },
        children: [
          {
            path: 'taxReceiptReport',
            name: 'TaxReceiptReport',
            component: () => import('@/views/ryt/applicationCenter/taxReceiptReport/index.vue'),
            meta: {
              title: '税票报告'
            }
          },
          {
            path: 'creditAnalysis',
            name: 'CreditAnalysis',
            component: () => import('@/views/ryt/applicationCenter/creditAnalysis/index.vue'),
            meta: {
              title: '征信解析'
            }
          }
        ]
      },
      {
        path: 'memberSetting',
        name: 'MemberSetting',
        component: () => import('@/views/ryt/memberSetting/index.vue'),
        meta: {
          title: '会员设置'
        }
      },
      {
        path: 'memberPayOrder',
        name: 'MemberPayOrder',
        component: () => import('@/views/ryt/memberPayOrder/index.vue'),
        meta: {
          title: '会员付费订单'
        }
      },

      {
        path: 'askCentre',
        name: 'AskCentre',
        component: () => import('@/views/ryt/askCenter/index.vue'),
        meta: {
          title: '询单中心'
        }
      },
      {
        path: 'publicMessage',
        name: 'PublicMessage',
        component: () => import('@/views/ryt/publicMessage/index.vue'),
        meta: {
          title: '群发消息管理'
        }
      },
      {
        path: 'operationManage',
        name: 'OperationManage',
        meta: {
          title: '运营管理'
        },
        children: [
          {
            path: 'operationContent',
            name: 'OperationContent',
            component: () => import('@/views/ryt/operationManage/operationContent/index.vue'),
            meta: {
              title: '内容管理'
            }
          },
          {
            path: 'operationActivity',
            name: 'OperationActivity',
            component: () => import('@/views/ryt/operationManage/operationActivity/index.vue'),
            meta: {
              title: '装扮配置'
            }
          },
          {
            path: 'operationDialog',
            name: 'operationDialog',
            component: () => import('@/views/ryt/operationManage/operationDialog/index.vue'),
            meta: {
              title: '弹窗配置'
            }
          }
        ]
      }
    ]
  }
]
